/*
 * Copyright (c) 2017 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _regeneratorRuntime = require("D:\\Schooldocumenten\\Masterproef_projects\\intersection_visualisation_demo\\intersection_visualisation_demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("D:\\Schooldocumenten\\Masterproef_projects\\intersection_visualisation_demo\\intersection_visualisation_demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("D:\\Schooldocumenten\\Masterproef_projects\\intersection_visualisation_demo\\intersection_visualisation_demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Schooldocumenten\\Masterproef_projects\\intersection_visualisation_demo\\intersection_visualisation_demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _require = require('./util'),
    callbackify = _require.callbackify,
    normalizeDocumentLoader = _require.normalizeDocumentLoader;

module.exports =
/*#__PURE__*/
function () {
  /**
   * Creates a simple queue for requesting documents.
   */
  function RequestQueue() {
    _classCallCheck(this, RequestQueue);

    this._requests = {};
    this.add = callbackify(this.add.bind(this));
  }

  _createClass(RequestQueue, [{
    key: "wrapLoader",
    value: function wrapLoader(loader) {
      var self = this;
      self._loader = normalizeDocumentLoader(loader);
      return function ()
      /* url */
      {
        return self.add.apply(self, arguments);
      };
    }
  }, {
    key: "add",
    value: function () {
      var _add = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(url) {
        var self, promise;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;
                promise = self._requests[url];

                if (!promise) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", Promise.resolve(promise));

              case 4:
                // queue URL and load it
                promise = self._requests[url] = self._loader(url);
                _context.prev = 5;
                _context.next = 8;
                return promise;

              case 8:
                return _context.abrupt("return", _context.sent);

              case 9:
                _context.prev = 9;
                delete self._requests[url];
                return _context.finish(9);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5,, 9, 12]]);
      }));

      function add(_x) {
        return _add.apply(this, arguments);
      }

      return add;
    }()
  }]);

  return RequestQueue;
}();